import * as React from 'react';
import autobind from 'autobind-decorator';

import { AllotmentDataService } from 'src/app/products/allotment/form/allotment-form.data';
import { ProductAllotmentView } from './product-allotment.view';
import { ObjectUtils } from 'src/core/utils/object';

interface ProductAllotmentControllerProps {
	value: number | null;
	mode: ControlMode;
	onChanged: (value: AllotmentItem | null) => void;
	setBusy(isBusy: boolean);
	label?: string;
	addAllotment?: AllotmentItem;
	placeholder?: string;
	supplierId?: number;
	productId?: number;
	afterLoad?: (selectedOptions: any, options: any[]) => void;

}
interface State {
	options?: AllotmentItem[];
}
export class ProductAllotmentController extends React.Component<ProductAllotmentControllerProps, State> {
	protected allotmentDataService: AllotmentDataService;
	constructor(props) {
		super(props);
		this.allotmentDataService = AllotmentDataService.make();
		this.allotmentDataService.searchKeywords = "";
		this.state = {};

	}
	loadOptions(productId?: number, supplierId?: number) {
		this.props.setBusy(true);
		this.allotmentDataService.addFilter('isDeleted', 'eq', false);
		this.allotmentDataService.addSorting('id', 'asc', true);
		
		if (productId != null) {
			this.allotmentDataService.addFilter('productId', 'eq', productId);
		}
		else if (productId == null) {
			this.allotmentDataService.removeFilter('productId');
		}
		if (supplierId != null) {
			this.allotmentDataService.addFilter('supplierId', 'eq', supplierId);
		}
		else if (supplierId == null) {
			this.allotmentDataService.removeFilter('supplierId');
		}
		this.allotmentDataService
			.load(query => query)
			.then((items) => {
				this.props.setBusy(false);
				let options = items.slice();
				if (this.props.addAllotment) {
					let add = options.find(x => ObjectUtils.equals(x, this.props.addAllotment));
					if (add == null) {
						options.push(this.props.addAllotment);
					}

				}
				this.setState({ options: [...options] })
			});
	}
	public componentDidMount() {
		this.loadOptions(this.props.productId, this.props.supplierId);
		
	}
	componentWillReceiveProps(nextProps: Readonly<ProductAllotmentControllerProps>, nextContext: any) {
		if (nextProps.productId!= this.props.productId || nextProps.supplierId!= this.props.supplierId) {
			this.loadOptions(nextProps.productId, nextProps.supplierId);
		}
		if (nextProps.addAllotment != this.props.addAllotment) {
			let add = this.state.options.find(x => ObjectUtils.equals(x, nextProps.addAllotment));
			if (add == null) {
				this.setState({ options: [...this.state.options, nextProps.addAllotment] })
				
			}
		}

	}
	

	render() {
		if (this.state.options == null)
			return null;
		return (
			<ProductAllotmentView
				afterLoad={this.props.afterLoad}
				placeholder={this.props.placeholder}
				options={this.state.options}
				label={this.props.label}
				onChanged={this.props.onChanged}
				value={this.props.value}
				mode={this.props.mode}
				supplierId={this.props.supplierId}
			>
				{this.props.children}
			</ProductAllotmentView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/parts/product-allotment.controller.tsx